<vcl-dialog [showDialog]="navigationService.loadExitScreen" [buttonLabels]="copyService.copies.header_exit_button" [dialogTitle]="copyService.copies.header_exit_button.title" (dialogButtonClick)="clickTwoLinkOnb($event)" [id]="'dialogClose'" [buttonAlignment]="'horizontal'">
  <p id="dialogDescription">
    {{ copyService.copies.header_exit_button.description }}
  </p>
</vcl-dialog>

<div id="header" [ngClass]="headerClass">
  <div class="portal-header-img">
    <img id="headerImg" src="assets/images/itau_logo.svg" alt="{{copyService.copies.header_itau_logo_alt_image}}" />
  </div>
  <div *ngIf="close" class="portal-header-link">
    <p id="headerCloseText" class="link" (click)="closeApp()">{{header_close}}</p>
    <span id="headerCloseText" (click)="closeApp()" class="icon-itaufonts_fechar" [ngClass]="close_class"></span>
  </div>
</div>

<div class="steps" *ngIf="showSteps">
  <vcl-steps [amount]="amountSteps" [current]="currentStep" id="currentSteps">
  </vcl-steps>
</div>

<div class="steps" *ngIf="showTitle">
  <h1 id="headerTitle" class="header-title">{{headerTitle}}</h1>
</div>